import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { useIconContent } from './hooks/useIconContent.js';

var IconContent = function IconContent(props) {
  var _useIconContent = useIconContent(props),
    style = _useIconContent.style,
    svg = _useIconContent.svg,
    image = _useIconContent.image;
  var content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1 1",
    role: "presentation"
  }, svg), /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%"
  })), image && /*#__PURE__*/React.createElement("img", _extends({
    alt: "",
    role: "presentation",
    src: image.url,
    onLoad: image.onLoad,
    onError: image.onError
  }, image.style)));
  return style ? /*#__PURE__*/React.createElement("span", style, content) : content;
};

export { IconContent };
//# sourceMappingURL=IconContent.js.map
